import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { Problem } from './components/Problem';
import { WhyFailed } from './components/WhyFailed';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { ForWhom } from './components/ForWhom';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-[#050505] text-white font-sans selection:bg-brand-green selection:text-black" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=928009436591933&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <Nav data-id="element-3" />
      <main data-id="element-4">
        <Hero data-id="element-5" />
        <OpeningHook data-id="element-6" />
        <Problem data-id="element-7" />
        <WhyFailed data-id="element-8" />
        <Mechanism data-id="element-9" />
        <WhatYouGet data-id="element-10" />
        <ForWhom data-id="element-11" />
        <HowItWorks data-id="element-12" />
        <Proof data-id="element-13" />
        <FAQ data-id="element-14" />
        <Offer data-id="element-15" />
      </main>
      <Footer data-id="element-16" />
    </div>;
}